// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__j1VTC","page":"Pagination_page__RZzn-","active-page":"Pagination_active-page__obKBf"};